import Title from '../components/elements/title';
import SubTitle from '../components/elements/sub-title';
import UnorderedList from '../components/elements/unordered-list';

export const CookiePolicyNl = () => {
  return (
    <div>
      <Title>Cookies</Title>
      <p className="my-2">Laatst aangepast op 27 december 2021</p>
      <p>
        Om jou een betere service te bieden bij het bezoeken van websites maken de meeste sites gebruik van cookies. Dat
        zijn handige technieken die informatie verzamelen en gebruiken. Websites worden daardoor makkelijker in gebruik.
      </p>
      <SubTitle>Wat zijn Cookies</SubTitle>
      <p className="my-4">
        Cookies zorgen er bijvoorbeeld voor dat je ingelogd kan blijven op een website of dat jouw voorkeuren, zoals
        locatie- en taalinstellingen, worden onthouden. Daarnaast houden ze bij het online winkelen jouw digitale
        winkelwagentje bij. Ook kunnen websitehouders dankzij cookies zien hoe vaak hun sites - en welke pagina’s - door
        bezoekers worden bekeken.
      </p>
      <p className="my-4">
        Cookies zijn kleine tekstbestandjes die een website op de harde schijf van je computer zet op het moment dat je
        de site bezoekt. Je kunt ze op elk gewenst moment verwijderen. Dat gaat heel eenvoudig via de instellingen van
        jouw browser. Bedenk wel dat je na het verwijderen van cookies opnieuw jouw voorkeuren zal moeten instellen of
        opnieuw moet inloggen.
      </p>
      <p className="my-4">
        Belangrijk om te weten: het gebruik van cookies is veilig. E-mail en telemarketing acties zijn niet het gevolg
        van cookies. Cookies slaan namelijk jouw e-mailadres of telefoonnummer niet op, noch wordt er met behulp van
        cookies een tot een persoon herleidbaar profiel opgebouwd.
      </p>
      <SubTitle>Welke cookies gebruiken we</SubTitle>
      <p className="my-4">
        <span className="font-semibold">Cloudflare</span> word gebruikt om deze webshop zo veilig en snel mogelijk op uw
        scherm te toveren. Hiervoor worden bepaalde cookies bijgehouden. Voor meer informatie rond de werking van deze
        cookies, raadpleeg Cloudflares cookie policy.
      </p>
      <p className="my-4">
        <span className="font-semibold">Splitbee</span> cookies. Wij gebruiken Splitbee cookies om gegevens te
        verzamelen over jouw bezoek op onze website. Voor meer informatie rond de werking van deze cookies kan je de
        cookie en privacyverklaring van Splitbee bekijken.
      </p>
      <UnorderedList>
        <div>sb_uid</div>
      </UnorderedList>
    </div>
  );
};
